import { render, staticRenderFns } from "./_denied.vue?vue&type=template&id=6c873310&scoped=true&lang=pug&"
import script from "./_denied.vue?vue&type=script&lang=js&"
export * from "./_denied.vue?vue&type=script&lang=js&"
import style0 from "./_denied.vue?vue&type=style&index=0&id=6c873310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c873310",
  null
  
)

export default component.exports